import { AvailableProductTrialType } from '../../../b2b/types/AvailableProductTrialType';
import { InProductTrialCannotBeStartedReason } from '../../../b2b/types/InProductTrialCannotBeStartedReason';
import {
  MspInProductTrialCannotBeStartedReason,
  MspInProductTrialId,
} from '../../../../company/common/mspInProductTrialsTab/types/msp-in-product-trials-types';

export interface ProductItem {
  type: AvailableProductTrialType | MspInProductTrialId;
  title: string;
  description: string;
  imageAlignment: string;
  imageSrc: string;
  tooltipTextMapping:
    | { [reason in InProductTrialCannotBeStartedReason]: string }
    | { [reason in MspInProductTrialCannotBeStartedReason]: string };
  isDemoAvailable?: boolean;
  isHowToAvailable?: boolean;
  button1?: Button;
  button2?: Button;
  button3?: Button;
  button4?: Button;
  button5?: Button;
}

export interface AccordionItems {
  title: string;
  description: string;
  isOpen?: boolean;
  image?: {
    alt: string;
    src: string;
  };
}

export interface CardItem {
  cardName: string;
  text: string;
  icon: string;
  linkText?: string;
  href?: string;
}

export interface Button {
  buttonText: string;
  buttonId: string;
}

export interface GzLandingPageConfig {
  productItem: ProductItem;
  cardItems: Array<CardItem>;
  hasOutlineAroundAccordionItems?: boolean;
  accordionItems: Array<AccordionItems>;
  accordionItemsFaq?: Array<AccordionItems>;
}

export enum LandingPageEventsName {
  PRODUCT_ITEM = 'landingPageProductItemClick',
  SHOW_CARDS = 'backButtonClicked',
  MSP_TRIAL_ACTION = 'mspAction',
}

export enum Themes {
  LIGHT = 'light',
  DARK = 'dark',
}
